import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import config from "../../../../config";
import useAuth from "../../../../utils/auth";
import {Gallery} from "./useGalleries";

// All galleries (ordered by date desc), used to populate the "move to gallery" picker.
const useAllGalleries = () => {
  const auth = useAuth()

  const galleries = useQuery({
    queryKey: ['galleries-all'],
    queryFn: () =>
      axios
        .get<Gallery[]>(`${config.apiURL}/api/galleries`, {headers: {'Authorization': `Bearer ${auth.apiKey}`}})
        .then((res) => res.data),
  })

  return {
    ...galleries
  }
}

export default useAllGalleries
